
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Card } from '@/components/ui/card';
import PinEmailTransfer from '@/components/payment/pin-email-transfer/PinEmailTransfer';

interface LocationState {
  email?: string;
}

const PinTransfer = () => {
  const location = useLocation();
  const state = location.state as LocationState;
  
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="pt-12 pb-6 px-6">
        <h1 className="text-2xl font-bold text-center">Secure PIN Transfer</h1>
        <p className="text-gray-600 text-center mt-2">
          All transfers require PIN verification for enhanced security
        </p>
      </header>
      
      <main className="px-6 pb-24 pt-4">
        <div className="max-w-md mx-auto">
          <PinEmailTransfer />
        </div>
      </main>
      
      <Navbar />
    </div>
  );
};

export default PinTransfer;
